import ShPopconfirm from '@/components/Helpers/ShPopconfirm';

// @vue/component
export default {
  name: 'WidgetConfigurationSave',

  components: {
    ShPopconfirm,
  },

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    haveAnyChangesBeenDetected() {
      return this.$store.getters['widgets/haveAnyChangesBeenDetected'];
    },
    isAnyAgentsOrDepartmentsHaveBeenAssigned() {
      return this.$store.getters['widgets/isAnyAgentsOrDepartmentsHaveBeenAssigned'];
    },
  },

  methods: {
    async handleSaveConfiguration(options) {
      try {
        const { id } = this.$route.params;
        await this.$store.dispatch('widgets/saveConfiguration', id);
        this.$notify.success({
          title: 'Konfiguracja widgetu',
          message: `Zapisano konfigurację widgetu: ${this.widget.name}`,
          customClass: 'callmeweb-notification',
        });
        if (options.shouldBackToList) this.$router.push({ name: 'WidgetsList' });
      } catch (e) {
        console.log(e);
      }
    },
    async handleCancelConfiguration() {
      await this.$store.dispatch('widgets/cancelDetectedChanges');
      this.$router.push({ name: 'WidgetsList' });
    },
  },
};
